var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6,10.7c0.2,0,0.3,0,0.5,0c1.3,0,2.6,0,3.9,0c1.1,0,1.7,0.7,1.6,1.7c0,0.3-0.2,0.6-0.4,0.9c-2.9,3.4-5.9,6.7-8.8,10.1 c-0.7,0.8-1.7,0.8-2.5,0C7.8,20,4.9,16.6,1.9,13.3c-0.4-0.5-0.6-1.1-0.3-1.7c0.3-0.6,0.8-0.9,1.5-0.9c1.3,0,2.6,0,3.9,0 c0.1,0,0.3,0,0.4,0c0-0.2,0-0.3,0-0.5c0-2.8,0-5.6,0-8.5C7.4,0.6,8.1,0,9.1,0c1.9,0,3.9,0,5.8,0c1,0,1.7,0.6,1.7,1.7 c0,2.8,0,5.7,0,8.5C16.6,10.3,16.6,10.5,16.6,10.7z M21,12.2c-0.2,0-0.3,0-0.4,0c-1.5,0-3,0-4.5,0c-0.8,0-1-0.4-1-1c0-3,0-6.1,0-9.1 c0-0.1,0-0.3,0-0.5c-2,0-4,0-6.1,0C9,1.7,9,1.9,9,2c0,3.1,0,6.1,0,9.2c0,0.7-0.3,0.9-0.9,0.9c-1.5,0-2.9,0-4.4,0c-0.2,0-0.3,0-0.6,0 c3,3.5,6,6.8,9,10.3C15,19,18,15.6,21,12.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.6a9a51bedba0522391de8d334e3e8b38.svg";
export { ForwardRef as ReactComponent };